import { useMutation } from '@tanstack/react-query';

import type {
  AssignStaffToPermissionGroupParams,
  AssignStaffToPermissionGroupResponse,
  DeletePermissionGroupParams,
  DeletePermissionGroupResponse,
  SetPermissionGroupCashRegistersParams,
  SetPermissionGroupCashRegistersResponse,
  SetPermissionGroupPermissionsParams,
  SetPermissionGroupPermissionsResponse,
  UpdatePermissionGroupParams,
  UpdatePermissionGroupResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useSetPermissionGroupPermissionsMutation = () =>
  useMutation({
    mutationFn: (params: SetPermissionGroupPermissionsParams) =>
      HttpClient.request<SetPermissionGroupPermissionsResponse>({
        method: 'PUT',
        url: params.url,
        data: { permission_group: { keys: params.keys } },
      }),
  });

export const useSetPermissionGroupCashRegistersMutation = () =>
  useMutation({
    mutationFn: (params: SetPermissionGroupCashRegistersParams) =>
      HttpClient.request<SetPermissionGroupCashRegistersResponse>({
        method: 'PUT',
        url: params.url,
        data: {
          permission_group: { cash_register_ids: params.cashRegisterIds },
        },
      }),
  });

export const useDeletePermissionGroupMutation = () =>
  useMutation({
    mutationFn: (params: DeletePermissionGroupParams) =>
      HttpClient.request<DeletePermissionGroupResponse>({
        method: 'DELETE',
        url: `${params.url}/${params.id}`,
      }),
  });

export const useUpdatePermissionGroupMutation = () =>
  useMutation({
    mutationFn: (params: UpdatePermissionGroupParams) =>
      HttpClient.request<UpdatePermissionGroupResponse>({
        method: 'PUT',
        url: `${params.url}/${params.id}`,
        data: { permission_group: params.data },
      }),
  });

export const useAssignStaffToPermissionGroupMutation = () =>
  useMutation({
    mutationFn: (params: AssignStaffToPermissionGroupParams) =>
      HttpClient.request<AssignStaffToPermissionGroupResponse>({
        method: 'PUT',
        url: `${params.url}/${params.id}/assign_staff`,
        data: { permission_group: { staff_ids: params.staffIds } },
      }),
  });
